import React from "react";
var insideRender = false;
var forceUpdateQueue = [];
export function useQueuedForceUpdate(forceUpdate) {
  return function () {
    if (insideRender) {
      forceUpdateQueue.push(forceUpdate);
    } else {
      forceUpdate();
    }
  };
}
export function useQueuedForceUpdateBlock(callback) {
  // start intercepting force-update calls
  insideRender = true;
  forceUpdateQueue = [];

  try {
    var result = callback(); // stop intercepting force-update

    insideRender = false; // store queue or nothing if it was empty to execute useLayoutEffect only when necessary

    var queue_1 = forceUpdateQueue.length > 0 ? forceUpdateQueue : undefined; // run force-update queue in useLayoutEffect

    React.useLayoutEffect(function () {
      if (queue_1) {
        queue_1.forEach(function (x) {
          return x();
        });
      }
    }, [queue_1]);
    return result;
  } finally {
    insideRender = false;
  }
}